export default __webpack_public_path__ + "static/media/logo.887bff0b.png";